import { render, staticRenderFns } from "./MonthlyRequestsByProductsReportDetail.vue?vue&type=template&id=0b7d9fc4&scoped=true&"
import script from "./MonthlyRequestsByProductsReportDetail.vue?vue&type=script&lang=js&"
export * from "./MonthlyRequestsByProductsReportDetail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b7d9fc4",
  null
  
)

export default component.exports